import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ExtractionTaskCreatePage } from "@client/components/doc-center/extraction-task/extraction-task-create-page";

export const Route = createFileRoute("/_app/data-center/extraction/create")({
  // ?assetId= 从资产工作台「来源」区进入：按语料集预填文件、模板按资产模型过滤（26 号 P2 运行创建预填）
  validateSearch: z.object({ assetId: z.string().optional() }),
  component: ExtractionCreateRoute,
});

function ExtractionCreateRoute() {
  const { assetId } = Route.useSearch();
  return <ExtractionTaskCreatePage presetAssetId={assetId} />;
}
